(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Explore-more"] && !Shopify.designMode) return;
  try {
    
// Add any necessary JavaScript here for video handling or interactive elements

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  ( $ => {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super()
  
        // do we already have recommended products?
        const carousel = this.querySelector('.js-recommended-carousel')

        if( carousel ) {
          this.applySlick()
        } else {
          const handleIntersection = ( entries, observer ) => {
            if( !entries[0].isIntersecting ) {
              return
            }
    
            observer.unobserve( this )
    
            fetch( this.dataset.url )
              .then( response => response.text() )
              .then( text => {
                const innerHTML = new DOMParser()
                    .parseFromString( text, 'text/html' )
                    .querySelector( 'product-recommendations' )
    
                if( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
                  this.innerHTML = innerHTML.innerHTML
                  window.preloadImages( this )
                }
                  
              }).catch(e => {
                console.error(e);
              
              }).finally( this.applySlick.bind( this ) )
          }
    
          new IntersectionObserver( 
            handleIntersection.bind( this ), 
            {
              rootMargin: '0px 0px 200px 0px'
            }).observe(this)
        }
      }

      applySlick() {

        // sanity check
        const carousel = this.querySelector('.js-recommended-carousel')

        if( carousel ) {
          $(carousel).slick({
              arrows: false,
              dots: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 3,
              responsive: [
                  {
                      breakpoint: 600,
                      settings: {
                          arrows: false,
                          dots: true,
                          slidesToScroll: 1,
                          slidesToShow: 1,
                      }
                  },
                  {
                      breakpoint: 1024,
                      settings: {
                          arrows: false,
                          dots: true,
                          slidesToScroll: 1,
                          slidesToShow: 2,
                      }
                  }
              ]
          })
        }
      }
    }
  
    customElements.define('product-recommendations', ProductRecommendations);
  }) ( jQuery )


  } catch(e) { console.error(e); }
})();
})();
